export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "bb-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "bb-themeWrap" */'./ThemeImporter'),
  },
};
